import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [languages, setLanguages] = useState([]);
  const [lang, setLang] = useState(() => localStorage.getItem('ch_lang') || 'en');
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get('/public/languages').then((r) => {
      const list = r.data || [];
      setLanguages(list);
      const has = list.find((l) => l.code === lang);
      if (!has && list.length) {
        const def = list.find((l) => l.is_default) || list[0];
        setLang(def.code);
      }
      setLoaded(true);
    }).catch(() => setLoaded(true));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeLang = useCallback((code) => {
    setLang(code);
    localStorage.setItem('ch_lang', code);
    document.documentElement.setAttribute('lang', code);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('lang', lang);
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ languages, lang, changeLang, loaded }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
